import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./MyLead";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";
import { Tag } from "primereact/tag";
import { TransferLead } from "./TransferLead";
import { Search } from "../../shared/Search";
import { LeadRequirement } from "./LeadRequirement";
import { ActionMenu } from "./ActionMenu";
import { showDateTime } from "../../utilities/helper";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
    const [expandedSections, setExpandedSections] = useState<{ [rowId: string]: { req?: boolean; } }>({});
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [filter, setFilter] = useState<IFilter>({});
    const [text, setText] = useState<string | null>(null);
    const [openCallDailor, setOpenCallDailor] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [openCallHistory, setOpenCallHistory] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [selectedContacts, setSelectedContacts] = useState<any[]>([]);

    const [genLead, setGenLead] = useState(false);
    const hideGenLeadDialog = () => {
        setGenLead(false)
    };

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'updatedAt',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("lead/mylead", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { leads: ILead[], count: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.leads, count: data.count, status: data.status, loading: false });
            setSelectedContacts([]);
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openEdit = (rowDatauser: ILead, type: 'change_status_form' | 'status_h' | 'transfer_h' | 'itinerary' | 'update_invoice') => {
        props.setModal({ open: true, singleData: rowDatauser, type: type });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>My Lead</h4>
                </div>
                {selectedContacts.length > 0 && <Button loading={tableData.loading} style={{ height: '30px' }} label="TransferLead" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={() => setGenLead(true)} />}
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("MyLead", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    const leadFromTemplate = (rowData: ILead) => {
        return (<>
            {rowData.pocId !== undefined && rowData.pocId > 0 &&
                <span>{rowData.pocName}</span>}
            {rowData.userId !== undefined && rowData.userId > 0 &&
                <span>{rowData.userName}</span>}
        </>
        );
    };


    const toggleSection = (hotelId: number, section: 'req') => {
        setExpandedSections(prev => {
            const current = prev[hotelId] || {};
            const isCurrentlyOpen = !!current[section];

            const newSections = {
                [section]: !isCurrentlyOpen,
                contact: section === 'req' ? !isCurrentlyOpen : false
            };

            const updated = { ...prev, [hotelId]: newSections };

            const isAnySectionOpen = Object.values(newSections).some(Boolean);
            setExpandedRows(prevExpanded => ({
                ...prevExpanded,
                [hotelId]: isAnySectionOpen
            }));

            return updated;
        });
    }

    const rowExpansionTemplate = (lead: any) => {
        const rowExpanded = expandedSections[lead.id] || {};
        return (
            <>
                {rowExpanded.req && <LeadRequirement leadId={lead.id} singleData={lead} toast={props.toast} />}
            </>
        );
    };

    const callOnNumber = async (body?: any) => {
        body = {
            number: body.phoneNumber
        }
        const response = await Fetch("IVR/call", "POST", body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Calling Successfully", life: 3000 });
            //  props.loadTableData();
            // props.setReload(!props.reload);
            // props.HidePenFollowup(); 
        }
    };

    const actionBodyTemplateDropDown = (rowData: ILead) => {
        return <ActionMenu
            rowData={rowData}
            hasPermission={props.hasPermission}
            open={openEdit}
            toggleSection={toggleSection}
            hasReq={rowData.hasRequirement ? true : false}
        />
    };

    // const actionBodyTemplate = (rowData: ILead) => {
    //     return (
    //         <div className="flex items-center ">
    //             <div className="flex items-center ">
    //                 {props.hasPermission("MyLead", "Edit") && (<Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success" onClick={() => openEdit(rowData)} tooltip="Edit Lead" tooltipOptions={{ position: "top" }} />)}

    //                 {props.hasPermission("MyLead", "History") && (<Button icon="pi pi-history" className="p-button-rounded p-button-text p-button-info" onClick={() => showHistoryDialog(rowData)} tooltip="View History" tooltipOptions={{ position: "top" }} />)}

    //                 {props.hasPermission("MyLead", "Requirement") && (
    //                     <Button icon="pi pi-book" className="p-button-rounded p-button-text p-button-warning" onClick={() => { if (rowData.id) { toggleSection(rowData.id, 'req') } }} tooltip="Requirements" tooltipOptions={{ position: "top" }} />)}

    //                 {rowData.hasRequirement &&
    //                     props.hasPermission("MyLead", "Itinerary") && (
    //                         <Button icon="pi pi-calendar" className="p-button-rounded p-button-text p-button-secondary" onClick={() => showItineraryDialog(rowData)} tooltip="Itinerary" tooltipOptions={{ position: "top" }} />)}
    //                 {rowData.hasRequirement &&
    //                     (
    //                         <Button className="p-button-rounded p-button-text p-button-secondary" onClick={() => setUpdateInvoice({ singleData: rowData, open: true })} tooltip="Update Invoice" tooltipOptions={{ position: "top" }} style={{ fontSize: '1.2rem' }}   >  ₹  </Button>
    //                     )}
    //             </div>

    //             <span className="border-l h-5 border-gray-300"></span>

    //             <div className="flex items-center gap-2">
    //                 {/* <Button icon="pi pi-phone" className="p-button-rounded p-button-text p-button-success"
    //                 onClick={() => { setOpenCallDailor({ open: true, singleData: rowData });callOnNumber(rowData); }} tooltip="Call" tooltipOptions={{ position: "top" }}  /> */}

    //                 <Button icon="pi pi-box" className="p-button-rounded p-button-text p-button-help"
    //                     onClick={() => setOpenCallHistory({ open: true, singleData: rowData })} tooltip="Transfer History" tooltipOptions={{ position: "top" }} />
    //             </div>
    //         </div>
    //     );
    // };



    const addressBody = (rowData: ILead) => {
        return (
            rowData.cityName ?
                <span>{rowData.cityName}, {rowData.stateName}, {rowData.countryName}</span> :
                <span>{rowData.stateName}, {rowData.countryName}</span>
        );
    }

    const statusBody = (rowData: ILead) => {
        return (
            <Tag severity={rowData.isLeadActive ? 'success' : 'danger'} value={rowData.statusName} rounded></Tag>
        );
    }

    return (
        <>
            <div className="flex align-items-center justify-content-start gap-2 p-2">
                <Tag className="cursor-pointer" onClick={() => setFilter((prev) => ({ ...prev, statusId: undefined }))} severity={filter.statusId === 0 || filter.statusId === undefined || filter.statusId === null ? 'warning' : 'info'} value={`All: ${tableData.count}`} rounded></Tag>
                {tableData.status.map((s) => {
                    return (
                        <Tag className="cursor-pointer" key={s.id} onClick={() => setFilter((prev) => ({ ...prev, statusId: s.id }))} severity={filter.statusId === s.id ? 'warning' : 'info'} value={`${s.name}: ${s.count}`} rounded></Tag>
                    )
                })}
            </div>
            <Filter toast={props.toast} header={"Filter"} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                selectionMode="checkbox" selection={selectedContacts} onSelectionChange={(e) => setSelectedContacts(e.value)}
                expandedRows={expandedRows}
                onRowToggle={(e: any) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column selectionMode="multiple"></Column>
                <Column field="contactName" header="Customer" />
                <Column field="contactContact" header="Contact" />
                   <Column field="alternativePhone" header="A.Contact" />
                <Column field="contactEmail" header="Email" />
                  <Column field="alternativeEmail" header="A.Email"  />
                <Column field="contactWhatsapp" header="Whatsapp" />
                <Column field="address" header="Address" body={addressBody} />
                <Column field="sourceName" header="Source" sortable />
                <Column field="" header="LeadFrom" body={leadFromTemplate} />
                <Column field="assignedToName" header="AssignedTo" />
                     <Column field="noOfPax" header="No-Of-Pax" />
                <Column field="statusName" header="Status" sortable body={statusBody} />
                <Column field="createdBy" header="Assigned By" />
                <Column field="createdAt" header="Assigned At" sortable body={(row) =>
                        row.createdAt
                            ? showDateTime(row.createdAt)
                            : "-"
                    } />
                <Column field="updatedBy" header="Updated By" />
                <Column field="updatedAt" header="Updated At" sortable body={(row) =>
                        row.updatedAt
                            ? showDateTime(row.updatedAt)
                            : "-"
                    } />
                       {/* <Column field="uploadedDate" sortable header="UploadedDate"  body={(row) =>
                        row.uploadedDate
                            ? showDateTime(row.uploadedDate)
                            : "-"
                    }/> */}
                <Column body={actionBodyTemplateDropDown} />
            </DataTable>
            <ConfirmDialog />
            <TransferLead onSuccess={loadTableData} open={genLead} hideDialog={hideGenLeadDialog} contacts={selectedContacts} toast={props.toast} />
        </>
    );
}
